import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../shared/DeleteButton.js';
import './AreaCardList.css';

const AreaCard = ({ row, onDeleted }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`area-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="area-card-main">
        <div className="area-card-name">{row.name || '—'}</div>
        <div className="area-card-chevron">{expanded ? '▲' : '▼'}</div>
        {row.matches && row.matches.length > 0 && (
          <div className="area-card-nicknames">{Array.isArray(row.matches) ? row.matches.join(', ') : row.matches}</div>
        )}
      </div>

      {expanded && (
        <div className="area-card-detail" onClick={e => e.stopPropagation()}>
          <div className="area-card-detail-row">
            <span>{t('nicknames')}</span>
            <span>{Array.isArray(row.matches) ? row.matches.join(', ') : row.matches || '—'}</span>
          </div>
          <div className="area-card-detail-row">
            <span>{t('created_by')}</span><span>{row.created_by || '—'}</span>
          </div>
          <div className="area-card-actions">
            <DeleteButton
              collection="areas"
              data={[row]}
              onComplete={onDeleted}
              onError={() => {}}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const AreaCardList = ({ data, onRefresh }) => {
  return (
    <div className="area-card-list">
      {data && data.map(row => (
        <AreaCard key={row._id} row={row} onDeleted={onRefresh} />
      ))}
      {(!data || data.length === 0) && (
        <div className="area-card-empty">—</div>
      )}
    </div>
  );
};

export default AreaCardList;
